import gql from 'graphql-tag';

// NOTE:
//
// These queries are excluded from gql schema generation.
// Make sure to write the interfaces in __client__ folder

export const ACTIVE_VAT_RATES = gql`
  query activeNorwegianVatRates($date: String!) {
    allNorwegianVatRates {
      symbol
      rate
      startDate
      endDate
    }
    activeNorwegianVatRates(date: $date) @client
    activeNorwegianVatRatesMap(date: $date) @client
  }
`;
